import { Component, OnInit } from '@angular/core';
import { CATEGORIES_de, Category } from '../../models/category';
import { Contact } from '../../models/contact.model';
import { ApiService } from '../../services/api.service';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-simple-form',
  templateUrl: './simple-form.component.html',
  styleUrls: ['./simple-form.component.scss']
})
export class SimpleFormComponent implements OnInit {

  contact = new Contact()
  categories = CATEGORIES_de
  isLoading = false;
  buttonMsg = "Kontaktiere uns"
  countries = ["Deutschland", "Österreich", "Schweiz"]
  services = ["Führerschein", "Personalausweis"]
  country = "Deutschland"
  service = "Führerschein"

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
    this.buttonMsg = "Kontaktiere uns"
  }

  submit() {
    this.buttonMsg = "Wird geladen...."
    this.contact.subject = "Country: "+ this.country + ", Service: " + this.service
    this.apiService.contact(this.contact)
      .subscribe((data: any) => {
        this.isLoading = true;
        Swal.fire({
          title: "Vielen Dank!",
          text: "Vielen Dank! Ihre Nachricht ist angekommen. Wir werden uns so schnell wie möglich bei Ihnen melden.",
          type: 'success',
          confirmButtonText: 'OK',
        })
        this.contact = new Contact();
        this.isLoading = false;
        this.buttonMsg = "Kontaktiere uns"
      },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          Swal.fire({
            title: "Error!",
            text: "Formular kann nicht gesendet werden. Stellen Sie sicher, dass Sie mit dem Internet verbunden sind",
            type: 'warning',
            confirmButtonText: 'OK!',
          })
          this.buttonMsg = "Kontaktiere uns"
        });
  }

}
